import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import TextField from 'components/TextField';
import Form from 'components/Form';

import { useErrorHandler } from 'lib';
import { LabelEditForm_label$key } from '__generated__/LabelEditForm_label.graphql';
import { LabelEditFormMutation } from '__generated__/LabelEditFormMutation.graphql';

type FormValues = {
  name: string;
};

type Props = {
  label: LabelEditForm_label$key;
};

const LabelEditForm: FC<Props> = ({ label }) => {
  const errorHandler = useErrorHandler();

  const { id, name } = useFragment(
    graphql`
      fragment LabelEditForm_label on Label {
        id
        name
      }
    `,
    label
  );

  const [update, loading] = useMutation<LabelEditFormMutation>(graphql`
    mutation LabelEditFormMutation($id: ID!, $input: UpdateLabelInput!) {
      updateLabel(id: $id, input: $input) {
        ...LabelSidebar_label
        ...LabelEditForm_label
      }
    }
  `);

  const initial = {
    name: name ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: { id, input },
        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={loading}>
        <Stack spacing={4}>
          <TextField autoFocus name="name" label="Pavadinimas" fullWidth />
        </Stack>
      </Form>
    </Formik>
  );
};

export default LabelEditForm;
